/// <reference types="vite/client" />
/// <reference types="vite-plugin-pwa/client" />

import setupAppSizeCalculator from './customer/util/setupAppSizeCalculator';
setupAppSizeCalculator();

import { Bootstrapper, whenIdle, whenVisible } from '@sitepark/dom-bootstrapper';
import '@sitepark/helper-lazyload';
import 'virtual:svg-icons-register';
import 'vite/modulepreload-polyfill';
import setupAutosizeTextArea from './customer/util/setupAutosizeTextArea';
import './setup/env';
import './setup/registerComponents';
import('./legacy');

import './customer/toc/TocMobile';
import './customer/toc/TocDesktop';
import './customer/serviceCard';
import { registerSW } from 'virtual:pwa-register';

setupAutosizeTextArea();
// Statusanzeige für HMR
if (import.meta.hot) {
	const doc = document.documentElement;
	doc.classList.add('sg-hmr');
	import.meta.hot.on('vite:beforeUpdate', () => doc.classList.add('sg-hmr-inprogess'));
	import.meta.hot.on('vite:afterUpdate', () => doc.classList.remove('sg-hmr-inprogess'));
}

// ServiceWorker registrieren
registerSW();

Bootstrapper.register('data-sp-annotationviewer', async () => (await import('@sitepark/component-annotation-viewer')).AnnotationViewer);

Bootstrapper.register('data-sp-navigation-multilevelpush', async () => (await import('./customer/Navigation')).CustomNavigation);

Bootstrapper.register('data-sp-table', async () => (await import('@sitepark/component-table')).CompatTableInitializer);

Bootstrapper.register('data-sp-more-like-this-slider', async () => (await import('./customer/Swiper/MoreLikeThisSlider')).MoreLikeThisSlider);
Bootstrapper.register('data-sp-stage-slider', async () => (await import('./customer/Swiper/StageSlider')).StageSlider);
Bootstrapper.register('data-sp-gallery-slider', async () => (await import('./customer/Swiper/GallerySlider')).GallerySlider);
Bootstrapper.register('data-sp-news-slider', async () => (await import('./customer/Swiper/NewsSlider')).NewsSlider);
Bootstrapper.register('data-sp-event-slider', async () => (await import('./customer/Swiper/EventSlider')).EventSlider);

Bootstrapper.register(
	'data-sp-picture-gallery',
	whenVisible(async () => (await import('./customer/photoswipe/CustomerGalleryZoom')).CustomerGalleryZoom),
);
Bootstrapper.register(
	'data-sp-figure-zoom',
	whenVisible(async () => (await import('./customer/photoswipe/CustomerPictureZoom')).CustomerPictureZoom),
);
Bootstrapper.register(
	'data-sp-picture-swiper-zoom',
	whenVisible(async () => (await import('./customer/photoswipe/CustomerSwiperZoom')).CustomerSwiperZoom),
);

Bootstrapper.register('data-sp-offcanvas', async () => (await import('./customer/OffCanvas')).Offcanvas);

Bootstrapper.register('data-sp-dialog-manager', async () => (await import('@sitepark/component-dialog')).DialogController);

Bootstrapper.register('data-sp-emergencymessages', async () => (await import('@sitepark/component-emergency-messages')).EmergencyMessages);

Bootstrapper.register(
	'data-sp-search-map-result-view',
	whenVisible(async () => (await import('./customer/search/MapSearchResult')).MapSearchResult),
);

Bootstrapper.register(
	'data-sp-map',
	whenVisible(async () => (await import('./customer/map/Map')).Map),
);

Bootstrapper.register('data-sp-print-link-references', async () => (await import('@sitepark/print-basics')).CreateLinkReferencesForPrint);
Bootstrapper.register('data-sp-privacy-barrier', async () => (await import('@sitepark/component-privacy-barrier')).PrivacyBarrier);
Bootstrapper.register('data-sp-privacy-barrier-dialog', async () => (await import('@sitepark/component-privacy-barrier')).PrivacyBarrierInDialog);
Bootstrapper.register('data-sp-clipboard', async () => (await import('@sitepark/component-clipboard')).CopyToClipboard);

Bootstrapper.register('data-sp-iframe', async () => (await import('@sitepark/component-iframe')).Iframe);
Bootstrapper.register('data-sp-email', async () => (await import('@sitepark/component-email')).Email);

Bootstrapper.register(
	'data-ilink',
	whenIdle(async () => (await import('@sitepark/component-ilink')).ILink),
);

Bootstrapper.register('data-sp-webpush-topic-subscription', async () => (await import('@sitepark/component-webpush')).WebpushTopicSubscription);
Bootstrapper.register('data-sp-webpush-topic-toggle', async () => (await import('@sitepark/component-webpush')).WebpushTopicToggle);

Bootstrapper.register('data-sp-masonry', async () => (await import('@sitepark/component-masonry')).MasonryWrapperLib);
